import React from 'react';
import { useStudioTypeSize } from '../../StudioTypeScale';
import { resolveTwoColumnContent } from '../../../../utils/contentCopy';
import SpotlightFrame, {
  type SpotlightInjectedProps,
  type SpotlightLayoutProps,
  type SpotlightTokens
} from './SpotlightFrame';

const SpotlightColumn: React.FC<{
  title: string;
  items: string[];
  isStory?: boolean;
  tokens: SpotlightTokens;
}> = ({ title, items, isStory, tokens: t }) => {
  const typeSize = useStudioTypeSize();
  return (
  <div
    style={{
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      border: `1px solid ${t.line}`,
      background: t.panel
    }}
  >
    <div
      style={{
        padding: isStory ? '10px 11px' : '8px 9px',
        color: t.onAccent,
        background: t.accent,
        fontSize: typeSize(isStory ? 12 : 10),
        fontWeight: 800,
        letterSpacing: 0.2,
        lineHeight: 1.25
      }}
    >
      {title}
    </div>
    <div style={{ padding: isStory ? '5px 12px 10px' : '4px 10px 8px' }}>
      {items.map((item, index) => (
        <div
          key={`${index}-${item}`}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 7,
            padding: isStory ? '9px 0' : '7px 0',
            borderBottom: index === items.length - 1 ? 'none' : `1px solid ${t.line}`,
            color: t.ink,
            fontSize: typeSize(isStory ? 11.5 : 9.8),
            fontWeight: 650,
            lineHeight: 1.4
          }}
        >
          <span
            style={{
              width: 5,
              height: 5,
              marginTop: isStory ? 6 : 5,
              borderRadius: '50%',
              background: t.accent,
              flexShrink: 0
            }}
          />
          <span>{item}</span>
        </div>
      ))}
    </div>
  </div>
  );
};

const SpotlightTwoColumnsContent: React.FC<SpotlightInjectedProps & { content: any }> = ({
  content,
  tokens,
  isStory,
  locale
}) => {
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const resolved = resolveTwoColumnContent(content, locale);

  return (
    <div>
      <h2
        style={{
          maxWidth: 305,
          margin: isStory ? '0 0 22px' : '0 0 16px',
          color: t.ink,
          fontSize: typeSize(isStory ? 31 : 25),
          fontWeight: 900,
          letterSpacing: '-1px',
          lineHeight: 1.08
        }}
      >
        {resolved.title}
      </h2>
      <div style={{ display: 'flex', gap: isStory ? 10 : 8 }}>
        <SpotlightColumn title={resolved.leftTitle} items={resolved.leftItems} isStory={isStory} tokens={t} />
        <SpotlightColumn title={resolved.rightTitle} items={resolved.rightItems} isStory={isStory} tokens={t} />
      </div>
    </div>
  );
};

const SpotlightTwoColumnsLayout: React.FC<SpotlightLayoutProps> = props => (
  <SpotlightFrame {...props}>
    <SpotlightTwoColumnsContent content={props.content || {}} />
  </SpotlightFrame>
);

export default SpotlightTwoColumnsLayout;
